import {CustomButtonToggleOption} from '../../_types/shared';

export enum ReportType {
    ENGAGEMENT = 'engagement',
    COMMENTS = 'comments',
    MEMBERS = 'members',
    MEMBERS_SEGMENTATION = 'members-segmentation',
    POLL_VOTES = 'poll-votes',
    RAW_ACTIVITY_LOG = 'raw-activity-log',
    RAW_POLLS_RESPONSES = 'raw-polls-responses',
    SUPPRESSION = 'suppression'
}

export const REPORT_TYPES: { type: ReportType; label: string; controls: string[] }[] = [
    {
        type: ReportType.ENGAGEMENT,
        label: 'Engagement',
        controls: ['communityId', 'subgroupId', 'segmentId', 'startDate', 'endDate']
    },
    {
        type: ReportType.COMMENTS,
        label: 'Comments',
        controls: ['communityId', 'postId', 'startDate', 'endDate']
    },
    {
        type: ReportType.MEMBERS,
        label: 'Members',
        controls: ['communityId', 'memberId', 'startDate', 'endDate']
    },
    {
        type: ReportType.MEMBERS_SEGMENTATION,
        label: 'Members Segmentation',
        controls: ['communityId', 'memberId', 'startDate', 'endDate']
    },
    {
        type: ReportType.POLL_VOTES,
        label: 'Poll Votes',
        controls: ['communityId', 'pollId', 'startDate', 'endDate']
    },
    {
        type: ReportType.RAW_ACTIVITY_LOG,
        label: 'Raw Activity Log',
        controls: ['communityId', 'subgroupId', 'segmentId', 'activityType', 'memberId', 'postId', 'startDate', 'endDate']
    },
    {
        type: ReportType.RAW_POLLS_RESPONSES,
        label: 'Polls Responses',
        controls: ['communityId', 'memberId', 'postId']
    },
    {
        type: ReportType.SUPPRESSION,
        label: 'Suppression List',
        controls: []
    },
];

export const BI_TYPES: { type: ReportType; label: string; controls: string[] }[] = [
    {
        type: ReportType.ENGAGEMENT,
        label: 'Engagement',
        controls: ['communityId', 'subgroupId', 'segmentId', 'startDate', 'endDate']
    },
    {
        type: ReportType.MEMBERS,
        label: 'Members',
        controls: ['communityId', 'memberId', 'startDate', 'endDate']
    },
    {
        type: ReportType.MEMBERS_SEGMENTATION,
        label: 'Members Segmentation',
        controls: ['communityId', 'memberId', 'startDate', 'endDate']
    },
    {
        type: ReportType.POLL_VOTES,
        label: 'Poll Votes',
        controls: ['communityId', 'pollId', 'startDate', 'endDate']
    },
    {
        type: ReportType.RAW_ACTIVITY_LOG,
        label: 'Raw Activity Log',
        controls: ['communityId', 'subgroupId', 'segmentId', 'activityType', 'memberId', 'postId', 'startDate', 'endDate']
    },
    {
        type: ReportType.RAW_POLLS_RESPONSES,
        label: 'Polls Responses',
        controls: ['communityId', 'memberId', 'postId']
    }
];


export const ACTIVITY_TYPES: CustomButtonToggleOption[] = [
    {value: 'commented', label: 'Commented'},
    {value: 'create', label: 'Create'},
    {value: 'create-discussion', label: 'Create Discussion'},
    {value: 'delete', label: 'Delete'},
    {value: 'dislike', label: 'Dislike'},
    {value: 'like', label: 'Like'},
    {value: 'login', label: 'Login'},
    {value: 'post-open', label: 'Post Open'},
    {value: 'profile-bio', label: 'Profile Bio'},
    {value: 'profile-pic', label: 'Profile Picture'},
    {value: 'receive-points', label: 'Receive Points'},
    {value: 'register', label: 'Register'},
    {value: 'replied', label: 'Replied'},
    {value: 'external-survey-complete', label: 'Survey Completed'},
    {value: 'undislike', label: 'Undislike'},
    {value: 'unlike', label: 'Unlike'},
    {value: 'update', label: 'Update'},
    {value: 'video-play', label: 'Video Play'},
    {value: 'vote-heatmap', label: 'Vote Heatmap'},
    {value: 'vote-poll', label: 'Vote Poll'}
];
